import toInteger from 'lodash/toInteger';
import { APP_HISTORY_CHANGE } from '../App/app.actions';
import { PROFILES_SEARCH_CHANGE } from '../Profiles/profiles.actions';
import {
    STORIES_FETCH_REQUEST,
    STORIES_FETCH_SUCCESS,
    STORIES_FETCH_FAILURE,
    STORIES_SEARCH_CHANGE,
    STORIES_PAGE_CHANGE,
} from './stories.actions';

/**
 * Stories reducer
 *
 * @param {{}} state Initial state object
 * @param {{}} action Action object
 * @returns {*} New state
 */
export default function stories(
    state = {
        query: '',
        from: null,
        to: null,
        items: [],
        itemsNum: 0,
        fetching: false,
        fetchFailed: false,
        page: 1,
        pagesNum: 0,
    },
    action,
) {
    switch (action.type) {
    /**
     * Stories loading start
     */
    case STORIES_FETCH_REQUEST:
        return Object.assign({}, state, {
            fetching: true,
            fetchFailed: false,
        });
    /**
     * Stories loaded
     * Store meta data to state
     */
    case STORIES_FETCH_SUCCESS:
        return Object.assign({}, state, {
            fetching: false,
            fetchFailed: false,
            page: action.payload.info.page.current_page,
            pagesNum: action.payload.info.page.num_pages,
            items: action.payload.records.page,
            itemsNum: action.payload.info.page.total_result_count,
        });
    /**
     * Stores loading failed
     */
    case STORIES_FETCH_FAILURE:
        return Object.assign({}, state, {
            fetching: false,
            fetchFailed: true,
        });
    /**
     * Search query was changed
     */
    case STORIES_SEARCH_CHANGE:
        return Object.assign({}, state, action.search);
    /**
     * Search page was changed
     */
    case STORIES_PAGE_CHANGE:
        return Object.assign({}, state, {
            page: action.page,
        });
    /**
     * Handle history state change
     */
    case APP_HISTORY_CHANGE: {
        const { query, from, to, page } = action.payload;
        const diff = {
            query: query || '',
            from: from || null,
            to: to || null,
            page: toInteger(page) || 1,
        };
        return Object.keys(diff).some(key => diff[key] !== state[key])
            ? Object.assign({}, state, diff)
            : state;
    }
    /**
     * Changes was done in profiles tab
     */
    case PROFILES_SEARCH_CHANGE: {
        const query = action.search.query;
        return query === state.query
            ? state
            : Object.assign({}, state, { query });
    }
    default:
        return state;
    }
}



// WEBPACK FOOTER //
// ./src/js/Stories/stories.reducer.js